<template>
  <div class="form-group" :class="currentWidth">
    <label>
      {{ idLabel }}
      <i v-if="statusIcon !== ''" class="icon icon-transaction-detail"
        v-bind:class="statusIcon"></i>
    </label>
    <input class="form-control inputAccordionForm" type="text" disabled='true'
          :value="inputValue"></input>
    <!-- Le slot par défaut pour afficher certains boutons comme le "View Transfer Order File" -->
    <slot></slot>
  </div>
</template>
<script>
/* @author TLV 24/06/2020
* @brief Component qui affiche les form-groups sur les détails d'une request (accès en lecture)
* @details Ce component a été créé pour permettre de modifier plus rapidement le visuel de ceux-ci si besoin
* @param formGroupWidth demande la largeur (nombre de colonnes bootstrap) pour le component
* @param idLabel demande l'id du label
* @param inputValue demande la valeur à afficher dans l'input
*/
export default {
  name: 'formReadGroupLabelInput',
  props: {
    formGroupWidth: {
      type: String,
      default: '6'
    },
    idLabel: {
      type: String
    },
    inputValue: {
      type: String
    },
    statusIcon: {
      type: String,
      default: ''
    }
  },
  computed: {
    currentWidth () {
      return 'col-sm-' + this.formGroupWidth
    }
  }
}
</script>



// WEBPACK FOOTER //
// formReadGroupLabelInput.vue?1ecb9070